export const isTransfer = (requestType: string): boolean => {
  return requestType === 'TRANSFER';
};

export const isBillPay = (requestType: string): boolean => {
  return requestType === 'BILLPAY';
};
